import { DocumentNode, gql } from '@apollo/client';
import { Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { MessageCircleIcon } from '@/imports/ui/chakra/feather';

import { CommentCount_PostFragment } from './graphql-types/CommentCount_PostFragment';

import { RespondButton } from '../../RespondButton';
import { useListOfAuthors } from '../hooks/useListOfAuthors';

export const CommentCount: React.FC<{
  post: CommentCount_PostFragment;
  onClick?: () => void;
}> & {
  postFragment: DocumentNode;
} = ({ post, onClick }) => {
  const commentAutorNames = post.comments.map(
    (comment) => comment.author.displayName
  );
  const { readableListOfAuthors } = useListOfAuthors(commentAutorNames, 6);

  return (
    <Tooltip
      label={readableListOfAuthors}
      isDisabled={!post.commentCount}
      placement="top"
      p="2"
    >
      <RespondButton
        leftIcon={<MessageCircleIcon />}
        onClick={onClick}
        color="gray.600"
        fontWeight="regular"
      >
        {post.commentCount}
      </RespondButton>
    </Tooltip>
  );
};

CommentCount.postFragment = gql`
  fragment CommentCount_PostFragment on PostV2 {
    _id
    commentCount
    comments {
      _id
      author {
        _id
        displayName
      }
    }
  }
`;
